export default __webpack_public_path__ + "static/media/recu5.02295224.png";